/**
 * Livre histoire compact — open/close, prev/next, swipe, clavier, auto-turn lecture.
 * Auto-tour pause si interaction ; referme à la fin. reduced-motion = pas d'auto-turn.
 */
(function () {
  'use strict';

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wordCount(el) {
    if (!el) return 40;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return 40;
    return text.split(' ').length;
  }

  function initBook(root) {
    if (!root || root.dataset.bookReady) return;
    root.dataset.bookReady = '1';

    var openBtn = root.querySelector('[data-book-open]');
    var closeBtn = root.querySelector('[data-book-close]');
    var cover = root.querySelector('[data-book-cover]');
    var reader = root.querySelector('[data-book-reader]');
    var pages = Array.prototype.slice.call(root.querySelectorAll('[data-book-page]'));
    var prevBtn = root.querySelector('[data-book-prev]');
    var nextBtn = root.querySelector('[data-book-next]');
    var progress = root.querySelector('[data-book-progress]');
    var wpm = parseInt(root.getAttribute('data-wpm'), 10) || 220;
    var minMs = parseInt(root.getAttribute('data-min-page-ms'), 10) || 8000;
    var index = 0;
    var autoTimer = null;
    var touchX = null;

    if (!pages.length || !openBtn || !reader) return;

    function clearAuto() {
      if (autoTimer) {
        window.clearTimeout(autoTimer);
        autoTimer = null;
      }
    }

    function updateProgress() {
      if (progress) progress.textContent = index + 1 + ' / ' + pages.length;
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= pages.length - 1;
    }

    function showPage(i) {
      index = Math.max(0, Math.min(pages.length - 1, i));
      pages.forEach(function (page, pi) {
        var on = pi === index;
        page.hidden = !on;
        page.classList.toggle('is-active', on);
      });
      updateProgress();
      scheduleAuto();
    }

    function scheduleAuto() {
      clearAuto();
      if (reducedMotion || document.hidden || reader.hidden) return;
      var body = pages[index] && pages[index].querySelector('[data-book-body]');
      var words = wordCount(body);
      var ms = Math.max(minMs, Math.round((words / wpm) * 60 * 1000));
      autoTimer = window.setTimeout(function () {
        if (index >= pages.length - 1) {
          closeBook();
        } else {
          showPage(index + 1);
        }
      }, ms);
    }

    function openBook() {
      root.classList.add('is-open');
      if (cover) cover.hidden = true;
      reader.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      showPage(0);
      if (nextBtn) nextBtn.focus();
    }

    function closeBook() {
      clearAuto();
      root.classList.remove('is-open');
      reader.hidden = true;
      if (cover) cover.hidden = false;
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }

    function pauseAutoOnInteract() {
      clearAuto();
      scheduleAuto();
    }

    openBtn.addEventListener('click', openBook);
    if (closeBtn) closeBtn.addEventListener('click', closeBook);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        pauseAutoOnInteract();
        showPage(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        pauseAutoOnInteract();
        if (index >= pages.length - 1) {
          closeBook();
        } else {
          showPage(index + 1);
        }
      });
    }

    root.addEventListener('keydown', function (e) {
      if (reader.hidden) return;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        pauseAutoOnInteract();
        if (index >= pages.length - 1) closeBook();
        else showPage(index + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        pauseAutoOnInteract();
        showPage(index - 1);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeBook();
      }
    });

    reader.addEventListener(
      'touchstart',
      function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) return;
        touchX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );

    reader.addEventListener(
      'touchend',
      function (e) {
        if (touchX === null || !e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) < 40) return;
        pauseAutoOnInteract();
        if (dx < 0) {
          if (index >= pages.length - 1) closeBook();
          else showPage(index + 1);
        } else {
          showPage(index - 1);
        }
      },
      { passive: true }
    );

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearAuto();
      else if (!reader.hidden) scheduleAuto();
    });
  }

  function init() {
    document.querySelectorAll('[data-canicule-history-book]').forEach(initBook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
